import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class NoteAPI {

  static getList = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(Config.app.link + 'api/note/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure) => {
    const filter = [{field: 'model', type: 'model', 'condition': 'equals',
      value: `${modelType}~${modelId}`}];
    const page = 1;
    const perPage = 10;
    fetch(Config.app.link + 'api/note/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (note, success, failure) => {
    fetch(Config.app.link + 'api/note/add-edit', new Header('POST', note))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/note/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default NoteAPI;